import React from 'react'
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined'
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined'
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined'
import { LicensePlan } from '../../types/license'
import { CommercialPackKey } from '../../utils/licensePacks'
import { GS } from './getStartedTheme'

export interface PlanCardConfig {
  key: LicensePlan
  pack: CommercialPackKey
  name: string
  highlights: string[]
  featured?: boolean
  icon: React.ReactNode
  color: string
  bg: string
  border: string
}

/** Get-started plan cards — Standard, Business, Premium (no seats). */
export const PLAN_CARDS: PlanCardConfig[] = [
  {
    key: 'basic',
    pack: 'standard',
    name: 'Standard',
    highlights: [
      'maturityScore',
      'frameworks',
      'unlimitedUsers',
      'emailSupport',
    ],
    icon: <ShieldOutlinedIcon />,
    color: GS.navy,
    bg: GS.surface2,
    border: GS.line,
  },
  {
    key: 'business',
    pack: 'business',
    name: 'Business',
    featured: true,
    highlights: [
      'maturityScore',
      'aiEvidence',
      'mapping',
      'integrations',
      'emailSupport',
    ],
    icon: <BusinessCenterOutlinedIcon />,
    color: GS.navy2,
    bg: '#EEF3FB',
    border: '#A8C0E8',
  },
  {
    key: 'premium',
    pack: 'premium',
    name: 'Premium',
    highlights: [
      'maturityScore',
      'rgpdModule',
      'onboarding',
      'phoneSupport',
      'consulting',
    ],
    icon: <WorkspacePremiumOutlinedIcon />,
    color: GS.tealDeep,
    bg: GS.tealSoft,
    border: '#B5DFD7',
  },
]
